
import { defineComponent, ref, } from 'vue';

import OperateHeader from './components/operateHeader.vue';
import AnalysisChart from './components/analysisChart.vue';
import RadarChart from './components/radarChart.vue';
import RoseChart from './components/roseChart.vue';

import moment from 'moment';

import { selectWeatherChart, } from './correlationReq';
import { message, } from 'ant-design-vue';

export default defineComponent({
  components: {
    OperateHeader,
    AnalysisChart,
    RadarChart,
    RoseChart,
  },
  setup () {
    const airType = ref<string>('pm25');
    const standardDataList = ref<any>([]);
    const radarDataList = ref<any>([]);
    const roseDataList = ref<any>([]);
    const isOverSeven = ref<boolean>(false);

    const params = {
      // endTime: '2022072623',
      endTime: moment().subtract(1, 'days').format('YYYYMMDD23'),
      // regionId: '2022072909',
      startTime: moment().subtract(1, 'days').format('YYYYMMDD00'),
      // startTime: '202206200000',
      stationName: '高淳老职中',
      stationType: '1',
    };

    const loadData = () => {
      selectWeatherChart(params).then((res: any) => {
        if (res) {
          const {
            barMap, lineMap, windDirection, windSpeed,
          } = res;

          standardDataList.value = {
            barMap,
            lineMap,
          };
          radarDataList.value = windSpeed;
          roseDataList.value = windDirection;
        } else {
          standardDataList.value.barMap = {};
          standardDataList.value.lineMap = {};
          radarDataList.value = [];
          roseDataList.value = [];
          message.warning('获取气象数据为空');
        }
      });
    };

    const typeChange = (val: string) => {
      airType.value = val;
    };

    const searchData = (data: any) => {
      const {
        startStr, endStr, selectedStation, selectedStationType,
      } = data;

      params.startTime = startStr;
      params.endTime = endStr;

      const diff = moment(endStr, 'YYYYMMDDhh').diff(moment(startStr, 'YYYYMMDDhh'), 'days');

      if (diff > 6) {
        isOverSeven.value = true;
      } else {
        isOverSeven.value = false;
      }

      params.stationName = selectedStation;
      params.stationType = selectedStationType;
      loadData();
    };

    return {
      airType,
      standardDataList,
      radarDataList,
      roseDataList,
      isOverSeven,
      typeChange,
      searchData,
      loadData,
    };
  },

  beforeCreate () {

    /*
     * 注释掉是因为需要获取到站点数据之后再请求列表数据，在operateHeader中进行初始化请求
     *  this.loadData();
     */
  },
});
